/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_7_Paragraphs_0Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_7_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_7_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begin with data entry and saving. Then learn cell references and a few formulas that solve your immediate problem. After the calculations are correct, use number formats and column widths to make the sheet easier to read. Add a chart only when you can name the question it answers. This order keeps a polished-looking sheet from hiding an incorrect calculation or an unsaved file.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_7_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_7_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先学习数据输入和保存，再学习单元格引用，以及能解决当前问题的少量公式。计算正确后，通过数字格式和列宽提高可读性。只有能够明确说出图表要回答的问题时，再加入图表。这种顺序能避免精美外观掩盖错误计算或未保存文件。`)
};

/**
* | output |
* | --- |
* | "Begin with data entry and saving. Then learn cell references and a few formulas that solve your immediate problem. After the calculations are correct, use nu..." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_7_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_7_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_7_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_7_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_7_paragraphs_0(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_7_paragraphs_0(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_7_paragraphs_0 as "gc.search_guides.what_is_gridcraft.sections.7.paragraphs.0" }